// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
'use client'
import { UnexpectedError } from '@/components/UnexpectedError'
import { PageProvider } from 'providers/PageProvider/PageProvider'
import { getObjectOfPublicEnvs } from 'lib/getObjectOfPublicEnvs'
import { getErrorPageData } from 'lib/getErrorAndNotFoundPageData'
import { Suspense, useEffect, useState } from 'react'

export default function Custom500Page() {
  const publicProcessDotEnv = getObjectOfPublicEnvs()
  const [pageProps, setPageProps] = useState(null)

  useEffect(() => {
    getErrorPageData().then(setPageProps)
  }, [])

  return (
    <Suspense fallback={null}>
      <PageProvider pageProps={pageProps ?? { publicProcessDotEnv }}>
        <UnexpectedError />
      </PageProvider>
    </Suspense>
  )
}
